var swiper = new Swiper(".tabsButtons", {
  loop: true,
  slidesPerView: 2,
  freeMode: true,
  watchSlidesProgress: true,
});

var swiper2 = new Swiper(".tabContent", {
  loop: true,
  spaceBetween: 10,
  thumbs: {
    swiper: swiper,
  },
});

const expandableSection = document.getElementById("expandableSection");
const handle = document.querySelector(".handle");

handle.addEventListener("click", toggleSection);

function toggleSection() {
  expandableSection.classList.toggle("expanded");
  if (expandableSection.classList.contains("expanded")) {
    expandableSection.style.transform = "translateY(0%)";
  } else {
    expandableSection.style.transform = "translateY(90%)"; // Match this to the initial translateY value in CSS
  }
}

function openReccom(evtevds, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evtevds.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpentab").click();
